export const getUserName = (name: string) => {
  //Rút gọn tên VD: Nguyễn Văn A => Nguyễn A
  const nameArr = name.trim().split(" ");
  if (nameArr.length > 2) {
    return nameArr[0].trim() + " " + nameArr[nameArr.length - 1].trim();
  } else {
    return name;
  }
};
